export const parsePlansFromText = (text: string): string[] => {
  // Recherche des plans qui commencent par "Plan" ou "###"
  const plans = text.split(/(?=(?:###|Plan)\s+\d+\s*:)/g)
    .filter(plan => plan.trim())
    .map(plan => plan.trim());

  console.log("Plans séparés:", plans);
  return plans;
};